import { definitions } from "../../common-fetch/generated/orders-model-api";
import { countries } from "../../common/generated/countries";
import { atom } from "../../common/miscellaneous/atom";
import { Override } from "../../common/miscellaneous/Override";
import { RecoilKeys } from "../../common/miscellaneous/RecoilKeys";

type CartAndOrderMerged = definitions["OrderDto"] & definitions["CartDto"];

type ShippingAddressOverride = Override<
  NonNullable<
    NonNullable<CartAndOrderMerged["shippingInformation"]>["shippingAddress"]
  >,
  { readonly countryIso?: typeof countries[number]["iso"] }
>;
type ShippingInformationOverride = Override<
  NonNullable<CartAndOrderMerged["shippingInformation"]>,
  { readonly shippingAddress?: ShippingAddressOverride }
>;

type BillingAddressOverride = Override<
  NonNullable<
    NonNullable<CartAndOrderMerged["paymentInformation"]>["billingAddress"]
  >,
  { readonly countryIso?: typeof countries[number]["iso"] }
>;
type PaymentInformationOverride = Override<
  NonNullable<CartAndOrderMerged["paymentInformation"]>,
  { readonly billingAddress?: BillingAddressOverride }
>;

export type OverrideOrder<T> = Override<
  T,
  {
    readonly paymentInformation?: PaymentInformationOverride;
    readonly shippingInformation?: ShippingInformationOverride;
  }
>;
export type CartAndOrder = OverrideOrder<CartAndOrderMerged>;

export type OrderState = CartAndOrder | "initializing";

export const orderAtom = atom<OrderState>({
  key: RecoilKeys.Order,
  default: "initializing",
});
